var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0001 29.0002C35.6735 29.0002 41.0834 23.5903 41.0834 16.9168C41.0834 10.2434 35.6735 4.8335 29.0001 4.8335C22.3266 4.8335 16.9167 10.2434 16.9167 16.9168C16.9167 23.5903 22.3266 29.0002 29.0001 29.0002Z",
    stroke: "#00CFC5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24072 53.1667C8.24072 43.8142 17.545 36.25 29 36.25",
    stroke: "#00CFC5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9834 51.7167C48.2544 51.7167 51.7167 48.2544 51.7167 43.9834C51.7167 39.7124 48.2544 36.25 43.9834 36.25C39.7124 36.25 36.25 39.7124 36.25 43.9834C36.25 48.2544 39.7124 51.7167 43.9834 51.7167Z",
    stroke: "#00CFC5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1667 53.1667L50.75 50.75",
    stroke: "#00CFC5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReq);
export default __webpack_public_path__ + "static/media/req.00cad0218e208064521f65f1a6a56d65.svg";
export { ForwardRef as ReactComponent };